module.exports = __webpack_public_path__ + "static/media/learning-is-fun-small.55297a42.jpg";